import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
import { MatxLoading } from '../components'

const AuthGuard = ({ children }) => {
    const { isAuthenticated } = useAuth()
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/session/signin', { 
                replace: true,
                state: { from: location.pathname }
            })
        }
    }, [isAuthenticated, navigate, location.pathname])

    if (!isAuthenticated) {
        return <MatxLoading />
    }

    return <>{children}</>
}

export default AuthGuard
